import React, {useCallback, useState, useEffect} from "react";
import {Button, Space} from "antd";
import CourseModal from "./course.modal";
import CatalogueItem from "./catalogue.item"
import CatalogueContentItem from './catalogue.content'
import CatalogueModal from './catalogue.modal'
import Api from '../../../api'

export default function Catalogue({courseId=0}) {
    const [showCtgModal, setShowCtgModal] = useState(false)
    const [curCataParams, setCurCataParams] = useState({})
    const [tree, setTree] = useState([])
    const [list, setList] = useState([])

    useEffect(() => {
        if (courseId) {
            Api.getCourseCatalogue(courseId).then(resp => {
                setTree(genTreeData(resp.list))
                setList(resp.list)
            })
        }
    }, [courseId])
    const OpenCtgModal = useCallback((item, isUpdate) => {
        setCurCataParams({
            parentId: isUpdate ? item.parentId : item.courseInfoId || 0,
            courseId: courseId,
            dicLevel: isUpdate ? item.dicLevel : (item.dicLevel || 0) + 1,
            courseInfoName: isUpdate ? item.courseInfoName : '',
            courseInfoId: isUpdate ? item.courseInfoId : undefined
        })
        setShowCtgModal(true)
    })
    const onCtgModalClose = useCallback((item) => {
        if (item) {
            let index = list.findIndex((node => node.courseInfoId === item.courseInfoId))
            if (index > -1) {
                Object.assign(list[index], item)
            } else {
                list.push(item)
            }
            setList(list)
            setTree(genTreeData(list))
        }
        setShowCtgModal(false)
    })

    const [showCourseModal, setShowCourseModal] = useState(false)
    const OpenCourseModal = useCallback((item, isUpdate) => {
        setCurCataParams({
            parentId: isUpdate ? item.parentId : item.courseInfoId || 0,
            courseId: courseId,
            dicLevel: isUpdate ? item.dicLevel : (item.dicLevel || 0) + 1,
            courseInfoName: isUpdate ? item.courseInfoName : '',
            sort: isUpdate ? item.sort : 1,
            typeCode: isUpdate ? item.typeCode : 1,
            filePath: isUpdate ? item.filePath : '',
            totalNumber: isUpdate ? item.totalNumber : 0,
            courseInfoId: isUpdate ? item.courseInfoId : undefined,
            coverImg: isUpdate ? item.coverImg : undefined
        })
        setShowCourseModal(true)
    })
    const onCourseModalClose = useCallback((item) => {
        if (item) {
            let index = list.findIndex((node => node.courseInfoId === item.courseInfoId))
            if (index > -1) {
                Object.assign(list[index], item)
            } else {
                list.push(item)
            }
            setList(list)
            setTree(genTreeData(list))
        }
        setShowCourseModal(false)
    })

    const onCourseInfoRemove = useCallback((courseInfoId)=>{
        if (courseInfoId) {
            let index = list.findIndex((node => node.courseInfoId === courseInfoId))
            if (index > -1) {
                list.splice(index, 1)
                setList(list)
                setTree(genTreeData(list))
            }
        }
    })

    const setSort = useCallback((courseInfoId, sort) => {
        Api.updateCourseInfoSort(courseInfoId, sort).then(resp=>{
            if (resp.resultCode === 1) {
                let index = list.findIndex((node => node.courseInfoId === courseInfoId))
                if (index > -1) {
                    list[index].sort = sort
                    setList(list)
                    setTree(genTreeData(list))
                }
            }
        })
    })

    return <>
        <div className="white-bg mgt12  pdv40 pdh32" style={{minWidth: 800, maxWidth: 1200}}>
            <div className="flexbox space-between">
                <span className="bold fts-18">课程目录（必填）</span>
                <Space>
                    <Button type="primary" onClick={OpenCourseModal}>创建内容</Button>
                    <Button onClick={() => OpenCtgModal({})}>创建一级目录</Button>
                </Space>
            </div>
            <div className="pdv20" style={{minHeight: 200}}>
                {tree.map(item1 => {
                    return item1.typeCode === 0 ?
                        <CatalogueItem
                            key={item1.courseInfoId}
                            data={item1}
                            level={1}
                            onSort={setSort}
                            OpenCourseModal={() => OpenCourseModal(item1)}
                            OpenCtgModal={(isUpdate) => OpenCtgModal(item1, isUpdate)}>
                            {item1.child && item1.child.map(item2 => {
                                return item2.typeCode === 0 ?
                                    <CatalogueItem
                                        key={item2.courseInfoId}
                                        data={item2}
                                        level={2}
                                        onSort={setSort}
                                        OpenCourseModal={() => OpenCourseModal(item2)}
                                        OpenCtgModal={(isUpdate) => OpenCtgModal(item2, isUpdate)}>
                                        {item2.child && item2.child.map(item3 => {
                                            return <CatalogueContentItem
                                                key={item3.courseInfoId}
                                                data={item3}
                                                level={3}
                                                onSort={setSort}
                                                OpenCourseModal={() => OpenCourseModal(item3, true)}/>
                                        })}
                                    </CatalogueItem> :
                                    <CatalogueContentItem
                                        key={item2.courseInfoId}
                                        level={2}
                                        data={item2}
                                        onSort={setSort}
                                        OpenCourseModal={() => OpenCourseModal(item2, true)}/>
                            })}
                        </CatalogueItem> :
                        <CatalogueContentItem
                            key={item1.courseInfoId}
                            level={1}
                            data={item1}
                            onSort={setSort}
                            OpenCourseModal={() => OpenCourseModal(item1, true)}/>
                })}
            </div>

        </div>
        <CatalogueModal isShow={showCtgModal} onClose={onCtgModalClose} onRemove={onCourseInfoRemove} params={curCataParams}/>
        <CourseModal isShow={showCourseModal} onClose={onCourseModalClose} onRemove={onCourseInfoRemove} params={curCataParams}/>
    </>
}


function genTreeData(list) {
    let nodes = [[], [], []]
    list.map(function (item) {
        nodes[item.dicLevel - 1].push(Object.assign({}, item))
    })
    sort(nodes[0])
    sort(nodes[1])
    sort(nodes[2])

    nodes[2].map(item2 => {
        let index = nodes[1].findIndex(item1 => {
            return item1.courseInfoId === item2.parentId
        })
        if (index === -1) return;
        if (!nodes[1][index].child) {
            nodes[1][index].child = []
        }
        nodes[1][index].child.push(Object.assign({}, item2))
    })
    nodes[1].map(item1 => {
        let index = nodes[0].findIndex(item => {
            return item.courseInfoId === item1.parentId
        })
        if (index === -1) return;

        if (!nodes[0][index].child) {
            nodes[0][index].child = []
        }
        nodes[0][index].child.push(Object.assign({}, item1))
    })

    return nodes[0]
}

function sort (list = []) {
    list.sort(function (item1,item2){
        if (item1.sort === item2.sort) {
            return item1.courseInfoId - item2.courseInfoId
        }
        return item1.sort - item2.sort
    })
}
